module.exports = __webpack_public_path__ + "static/img/home5.99f04afb.png";